/**
 * Logger centralisé pour le frontend mEyEbus
 *
 * Basé sur loglevel — remplace tous les console.* de l'application.
 *
 * Niveaux disponibles (du plus prioritaire au moins prioritaire) :
 *   error > warn > info > debug > trace
 *
 * En production (NODE_ENV=production) :
 *   - Niveau par défaut : warn (seuls warn et error sont affichés)
 *   - Les logs info/debug/trace sont silencieux
 *
 * En développement :
 *   - Niveau par défaut : debug (tout est affiché)
 *
 * Le niveau peut être surchargé via la variable d'environnement VITE_LOG_LEVEL.
 */

import log from 'loglevel';

// ─── Configuration du niveau ──────────────────────────────────────────────────
const level = import.meta.env.VITE_LOG_LEVEL || (import.meta.env.PROD ? 'warn' : 'debug');

log.setLevel(level);

// ─── Export ───────────────────────────────────────────────────────────────────
export default log;
